module.exports = __webpack_public_path__ + "media/images/search_b-30f512068f76e8c6e893e93fecd91459.png";